export default __webpack_public_path__ + "static/media/mail.e7d61b05.svg";